// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoSt3 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.st_3";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoSt3 {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Rebutjar cookies i accedir mitjançant registre",
                "cs": "Odmítnout cookies a získat přístup prostřednictvím registrace",
                "da": "Afvis cookies og få adgang via registrering",
                "de": "Cookies ablehnen und über Registrierung zugreifen",
                "el": "Απόρριψη cookies και πρόσβαση μέσω εγγραφής",
                "en": "Reject cookies and access through registration",
                "es": "Rechazar tecnologías similares a cookies y acceder mediante registro",
                "eu": "Cookieak baztertu eta erregistro bidez sartu",
                "fi": "Hylkää evästeet ja käytä rekisteröitymällä",
                "fr": "Refuser les cookies et accéder par l'inscription",
                "gl": "Rexeitar cookies e acceder mediante rexistro",
                "hi": "कुकी स्वीकार न करें और पंजीकरण के माध्यम से पहुंचें",
                "hu": "Sütik elutasítása és hozzáférés regisztrációval",
                "it": "Rifiuta i cookie e accedi tramite registrazione",
                "nl": "Cookies weigeren en toegang krijgen via registratie",
                "no": "Avvis informasjonskapsler og få tilgang via registrering",
                "pl": "Odrzuć pliki cookie i uzyskać dostęp poprzez rejestrację",
                "pt": "Rejeitar cookies e aceder através de registo",
                "ro": "Refuzați cookie-urile și accesați prin înregistrare",
                "ru": "Отклонить файлы cookie и получить доступ через регистрацию",
                "sv": "Avvisa cookies och få tillgång via registrering",
                "tr": "Çerezleri reddedin ve kayıt yoluyla erişin"
            },
            "defecto": "Reject cookies and access through registration"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
